// Tiny central store with pub/sub for incremental migration.
const state = {
  selectedGroup: ''
}

const subs = new Map()

export function subscribe(key, cb) {
  const list = subs.get(key) || []
  list.push(cb)
  subs.set(key, list)
  return () => {
    const cur = subs.get(key) || []
    subs.set(key, cur.filter(x => x !== cb))
  }
}

export function set(key, value) {
  state[key] = value
  const list = subs.get(key) || []
  list.forEach(cb => cb(value))
}

export function get(key) {
  return state[key]
}

export default { subscribe, set, get }
